var o = (t, e, r) => {
    let n = `Function ${e}: error: ${t}`;
    if (typeof r > "u") console.error(n);else {
      let i = n.concat(": ");
      console.error(i, r);
    }
  },
  d = (t, e) => {
    t instanceof Error ? o(t.message, e) : o("error without error object", e, t);
  };
var T = t => {
    if (t) return `[${t}]`;
  },
  S = t => {
    if (t) return document.getElementById(t) ?? void 0;
  },
  f = t => {
    if (t?.parentElement) return t.parentElement ?? void 0;
    let e = t?.parentNode;
    if (e?.getRootNode() instanceof ShadowRoot) {
      let r = e.getRootNode().host;
      if (r instanceof HTMLElement) return r;
    }
  },
  c = t => {
    if (t) {
      let e = "data-";
      if (t !== e) return t.startsWith(e) ? t : e.concat(t);
    }
  },
  P = t => {
    if (t) try {
      let e = document.createElement(t);
      if (e instanceof HTMLElement) return e;
    } catch (e) {
      d(e, "html createElement");
    }
  },
  v = (t, e) => {
    let r = c(e);
    if (r) return t.getAttribute(r) ?? void 0;
  },
  E = (t, e) => {
    let r = c(e);
    if (r) {
      let n = v(t, r);
      if (n && (t.removeAttribute(r), n = v(t, r), n)) return o("not removed dataAttribute", "HTML removeAttribute", r), !1;
    }
    return !0;
  },
  A = (t, e, r) => {
    let n = !1,
      i = c(e);
    if (i && r) try {
      t.setAttribute(i, r), n = !0;
    } catch (s) {
      d(s, "HTML setAttribute");
    }
    return n;
  };
var I = (t, e) => {
    if (e) try {
      let r = t.querySelector(`${t.tagName} > ${e}`) ?? void 0;
      if (r instanceof HTMLElement) return r;
    } catch (r) {
      d(r, "HTML querySelector");
    }
  },
  m = (t, e) => {
    let r = c(e),
      n = T(r);
    return I(t, n);
  };
var h = t => {
    let e = !1;
    return t.element && (e = !0), e;
  },
  L = (t, e) => {
    if (t instanceof HTMLElement) return m(t, e);
  },
  O = (t, e) => {
    let r = S(t);
    if (r) return L(r, e);
  },
  V = (t, e) => {
    let r = !1;
    return t && e && (t.append(e), r = !0), r;
  },
  g = t => {
    if (h(t)) return t.element;
    let e = S(t.elementID);
    if (e) return e;
    o("mountByDOMElementID", "element not found", t.elementID);
  },
  b = (t, e) => {
    let r = !1;
    return r = V(t, e), r;
  },
  H = (t, e) => {
    if (e) return h(t) ? L(t.element, e) : O(t.elementID, e);
  };
var a = class {
    #e = "v1";
    #t = [];
    constructor() {
      this.#t.push(this.#e);
    }
    getAPIVersion = () => this.#e;
    getSupportedAPIVersions() {
      return this.#t;
    }
  },
  y = t => t && "getService" in t && "addService" in t;
var p = class {
  #e;
  constructor() {
    this.#e = new Map();
  }
  getServiceMeta = e => {
    if (e) return this.#e.get(e);
  };
  getStateMapKeys = () => {
    let e = this.#e.keys();
    return Array.from(e);
  };
  setServiceMeta = (e, r) => {
    e && r && this.#e.set(e, r);
  };
};
var u = class t extends HTMLElement {
  #e;
  constructor() {
    super(), this.#e = new p();
  }
  static getAttributeIdentifierKey = () => "service-provider-api-version";
  static getHTMLTagName = () => {
    let e = "service-provider",
      r = "2.0.8";
    if (r) {
      let i = "-v",
        l = r.replaceAll(".", "-");
      return `${e}${i}${l}`.toLowerCase();
    }
    return e;
  };
  static #t(e, r) {
    let n = new RegExp("-v\\d+$"),
      i = e;
    if (!n.test(i)) {
      let s = r ?? new a().getAPIVersion();
      i = `${e}-${s}`;
    }
    return i;
  }
  static #r = e => {
    if (e) {
      let n = v(e, t.getAttributeIdentifierKey()),
        i = new a().getSupportedAPIVersions();
      if (n) try {
        let s = JSON.parse(n);
        return i.some(l => s.includes(l));
      } catch {
        return !1;
      }
    }
    return !1;
  };
  addService(e) {
    let r = e.apiVersion ?? new a().getAPIVersion(),
      n = `${e.name}-${e.version}-${r}`;
    if (this.getServiceMeta(n)) {
      o(`Service with the name '${e.name}' already added.`, "addService");
      return;
    }
    return this.#e.setServiceMeta(n, {
      ...e,
      apiVersion: r
    }), n;
  }
  connectedCallback() {
    this.style.display = "none";
    let e = t.getAttributeIdentifierKey(),
      r = new a().getSupportedAPIVersions();
    A(this, e, JSON.stringify(r)), this.#o();
  }
  disconnectedCallback() {
    E(this, t.getAttributeIdentifierKey());
  }
  getService(e, r) {
    let n = t.#t(e, r),
      i = this.getServiceMeta(n);
    if (i) return i.instance;
    console.warn(`Service with the key ${e} not found!`);
  }
  getServiceKeys = () => this.#e.getStateMapKeys();
  getServiceMeta(e, r) {
    let n = t.#t(e, r),
      i = this.#e.getServiceMeta(n);
    if (i) return i;
  }
  #n = e => {
    e.getServiceKeys().forEach(n => {
      let i = e.getServiceMeta(n);
      i && new a().getSupportedAPIVersions().includes(i.apiVersion) && this.#e.setServiceMeta(n, i);
    });
  };
  #i = () => {
    let e = f(this);
    for (; e;) {
      let r = m(e, t.getAttributeIdentifierKey());
      if (r === void 0 || r?.parentElement === this.parentElement) e = f(e);else if (t.#r(r)) return r;
    }
  };
  #o = () => {
    let e = this.#i();
    e && this.#n(e);
  };
};
var K = t => {
    let e = [],
      r = ["annotation-xml", "color-profile", "font-face", "font-face-src", "font-face-uri", "font-face-format", "font-face-name", "missing-glyph"].includes(t),
      n = /^[a-z]/u.test(t),
      i = /\s/u.test(t),
      s = /[A-Z]/u.test(t),
      M = t.includes("-");
    if (r && e.push("- Tag name is reserved"), n || e.push("- Does not start with a valid lower case letter (a-z)"), i && e.push("- Contains white space"), M || e.push("- Does not contain a hypen"), s && e.push("- Contains at least one upper case letter"), e.length > 0) {
      let l = `Provided tag name "${t}" has the following errors: 
`;
      throw l += e.join(`
`), new Error(l);
    }
  },
  C = t => {
    let e = !1;
    try {
      K(t), customElements.define(t, u), e = !0;
    } catch (r) {
      d(r, "html define"), o("Failed to register WebComponent to CustomElementRegistry", "html define"), o("Used CustomElementRegistery key", "html define", t), o("Registered Object", "html define", u);
    }
    return e;
  },
  w = t => {
    let e = !1;
    return customElements.get(t) || (e = C(t)), e = !0, e;
  },
  x = t => {
    let e = c(u.getAttributeIdentifierKey());
    if (t?.querySelector(`[${e}]`)) {
      console.error("MountElement has already appended a ServiceProvider instance!");
      return;
    }
    let n = u.getHTMLTagName();
    return w(n) ? P(n) : void 0;
  },
  D = class {
    static createServiceProvider = e => {
      let r = e.mountOptions,
        n = g(r),
        i = x(n);
      if (y(i) && b(n, i)) return i;
    };
    static getServiceProvider = e => {
      let r = e.mountOptions,
        n = c(u.getAttributeIdentifierKey()),
        i = H(r, n);
      if (y(i)) return i;
    };
  };
export { D as ServiceProviderFactory, u as ServiceProviderWebComponent };